var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPortalIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 24,
    viewBox: "0 0 33 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "live_tv_FILL0_wght400_GRAD0_opsz40",
    d: "M13.522,29V26.334H6.1a2.989,2.989,0,0,1-1.938-.667A1.968,1.968,0,0,1,3.333,24.1V7.234a1.971,1.971,0,0,1,.826-1.567A2.991,2.991,0,0,1,6.1,5H33.569a2.991,2.991,0,0,1,1.938.666,1.971,1.971,0,0,1,.826,1.567V24.1a1.968,1.968,0,0,1-.826,1.566,2.989,2.989,0,0,1-1.938.667H26.144V29ZM6.1,24.1H33.569V7.234H6.1Zm0,0v0Z",
    transform: "translate(-3.333 -5)",
    fill: "#707070"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortalIcon);
export default __webpack_public_path__ + "static/media/portal-icon.9dd97904abe3c667cac4f65876874d83.svg";
export { ForwardRef as ReactComponent };